import React from 'react';

import Hero from './Hero';
import Profile from './Profile';

import HighlightProject from '../Community/OneistoxLearner/HighlightProject';
import RecommendedProfile from './RecommendedProfile';

import Data from '../../content/global/community/userProfile.json';

const OneistoxLearnerProfile = ({ data }) => {
  return (
    <>
      <Hero data={data?.hero} />
      <Profile data={data?.profile} />
      <HighlightProject data={Data?.highlight} />
      <RecommendedProfile data={Data?.recommendedProfile} />
    </>
  );
};

export default OneistoxLearnerProfile;
